import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Api from "../../../../lib/componentApi";

import List from "../../../../components/Users/Favorites/List";
import Loading from "../../../../components/Common/Loading";

export default class FavoritesList extends Component {
  constructor(props) {
    super(props);
    let deliveryDetails;
    // eslint-disable-next-line
    if (__isBrowser__) {
      deliveryDetails = localStorage.getItem("deliveryDetails");
    }
    const favoritesData =
      (deliveryDetails && JSON.parse(deliveryDetails)) || {};
    this.state = {
      limit: 10,
      index: 1,
      delivery: favoritesData.delivery || true,
      collectionDistance: favoritesData.collectionDistance || null,
      userAddressId: favoritesData.userAddressId || null,
      lat: favoritesData.lat || null,
      lon: favoritesData.lon || null,
      recentFavorites: [],
      unavailableFavorites: [],
      loading: true,
      edit: false,
      selectedItems: []
    };
  }
  componentDidMount() {
    this.getFavorites();
  }
  getFavorites = () => {
    const {
      limit,
      index,
      delivery,
      collectionDistance,
      userAddressId,
      lat,
      lon
    } = this.state;
    Api.post(
      "/api/favorites",
      {
        limit,
        index,
        delivery,
        collectionDistance,
        userAddressId,
        lat,
        lon
      },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code");
        } else {
          const { favoritesRecent, favoritesUnavailable } = response || [];
          this.setState({
            recentFavorites: favoritesRecent,
            unavailableFavorites: favoritesUnavailable
          });
        }
        this.setState({ loading: false });
      }
    );
  };
  handleEdit = event => {
    event.preventDefault();
    const { edit } = this.state;
    this.setState({ edit: !edit });
  };
  handleSelectItem = event => {
    const { selectedItems } = this.state;
    const itemId = event.target.id;
    const itemIndex = selectedItems.indexOf(itemId);
    if (itemIndex === -1) {
      selectedItems.push(itemId);
    } else {
      delete selectedItems[itemIndex];
    }
    const newItems = selectedItems.filter(item => item !== null);
    this.setState({ selectedItems: newItems });
  };
  handleRemoveSelected = (event, items) => {
    event.preventDefault();
    const { selectedItems } = this.state;
    const restaurantUidList =
      (items && JSON.stringify([items])) || JSON.stringify(selectedItems);
    Api.post(
      "/api/favorites/delete",
      { restaurantUidList },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code");
        } else {
          if (response.status) {
            location.reload(true);
          }
        }
      }
    );
  };
  render() {
    const {
      recentFavorites,
      unavailableFavorites,
      loading,
      edit,
      selectedItems
    } = this.state;
    const { onCloseSection } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>Favorites</title>
          <meta property="og:title" content="Favorites" />
        </Helmet>
        <div className="profile-desktop">
          {/* Header */}
          <div className="head-general with-back">
            <a
              href="javascript: void(0)"
              onClick={() => onCloseSection("favoritesSection")}
              className="back"
            >
              <img src="/png/chevron-left.png" />
            </a>
            <h4>My Favorites</h4>
            <a
              href="javascript: void(0)"
              onClick={this.handleEdit}
              className="close"
            >
              {((!!recentFavorites.length || !!unavailableFavorites.length) &&
                ((!edit && "Edit") || <i className="icon icon-close" />)) || (
                <i className="icon icon-close  hide-xs" />
              )}
            </a>
          </div>
          {/* Header */}

          <div className="hide-xs">
            <h4 className="general-title d-flex align-items-center justify-content-between">
              <span>Your Favorites</span>
            </h4>
          </div>
          {(loading && <Loading />) ||
            ((!recentFavorites.length && !unavailableFavorites.length && (
              <div className="white-bg mt-10px empty-body empty-icon">
                <div className="empty-img">
                  <img src="/png/no-favorites.png" alt="" />
                </div>
                <p>You don{"'"}t have any favorites yet.</p>
              </div>
            )) || (
              <div>
                <List
                  recentFavorites={recentFavorites}
                  unavailableFavorites={unavailableFavorites}
                  edit={edit}
                  handleRemoveSelected={this.handleRemoveSelected}
                  handleSelectItem={this.handleSelectItem}
                  selectedItems={selectedItems}
                />
                {(edit && selectedItems.length && (
                  <div className="use-buttons visible-xs">
                    <button
                      className="btn btn-blue"
                      onClick={this.handleRemoveSelected}
                    >
                      Remove Selected
                    </button>
                  </div>
                )) || <noscript />}
              </div>
            ))}
        </div>
      </React.Fragment>
    );
  }
}
